<mb-dialog class="searchbox-dialog" [fullScreenMobile]="true">
  <mb-dialog-header [showCloseBtn]="true" (closeDialog)="closeDialog()"></mb-dialog-header>
  <mb-dialog-body class="searchbox-dialog__body">
    <am-search-box [country]="dialogData?.context?.site" [brand]="dialogData?.context?.brand"
      [channel]="dialogData?.context?.channel" [initialData]="dialogData?.initialData" [product]="'hotels'"
      [dataType]="'model'" [allowDollar]="dialogData?.context?.allowDollar" [disableARS]="dialogData?.disableARS" 
      (modelSearch)="handleSearch($event)">
    </am-search-box>
  </mb-dialog-body>
</mb-dialog>